// extracted by mini-css-extract-plugin
export default {"section":"Layout_section__yc1CK","container":"Layout_container__ee3vs","content":"Layout_content__X2eMW","link":"Layout_link__K3Xml"};